module.exports = __webpack_public_path__ + "img/Flag_of_Panama.c5fdecb5.svg";